// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/taskManage',
    name: 'TaskManage',
    component: layout,
    redirect: '/taskManage/index',
    meta: {
      title: '任务管理',
      icon: 'i-tabler:subtask',
      roles: [0, 2]
    },
    sort: 2,
    children: [
      {
        path: 'project',
        name: 'TaskManageProject',
        component: () => import('@/views/Manage/Task/Project.vue'),
        meta: {
          title: '项目列表',
          icon: 'i-tabler:cap-projecting',
          roles: [0, 2]
        }
      },
      {
        path: 'task',
        name: 'TaskManageTask',
        component: () => import('@/views/Manage/Task/Task.vue'),
        meta: {
          title: '任务列表',
          icon: 'i-tabler:clipboard-list',
          roles: [0, 2]
        }
      }
    ]
  }
]
export default routes
